import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { list } from "../../../services/badge";
import { list as rejectedReasons } from "../../../services/rejectedReason";
import Select from "react-select";

class UpdateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: {},
            badges: [],
            rejectedReasons: []
        };
    }

    componentDidMount() {
        list()
            .then(res => {
                this.setState({ badges: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        rejectedReasons()
            .then(res => {
                this.setState({ rejectedReasons: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        this.setState({ item: this.props.item });
    }

    update = e => {
        e.preventDefault();
        this.props
            .update(this.props.item.id, this.state.item)
            .then(response => {
                this.props.hideUpdate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }
    handleSelectChange = selectedOption => {
        let temp = this.state.item;
        temp["badges"] = [];
        temp["user_badges"] = [];

        if (selectedOption !== null) {
            for (let index = 0; index < selectedOption.length; index++) {
                temp["badges"][index] = selectedOption[index].value;
                temp["user_badges"].push({
                    badge_id: selectedOption[index].value
                });
            }
        }
        let error = this.state.errors;
        error.badges = null;

        this.setState({ item: temp, errors: error });
    };

    handleRejectSelectChange = selectedOption => {
        let temp = this.state.item;
        temp["rejectedReasons"] = [];
        temp["UserRejects"] = [];

        if (selectedOption !== null) {
            for (let index = 0; index < selectedOption.length; index++) {
                temp["rejectedReasons"][index] = selectedOption[index].value;
                temp["UserRejects"].push({
                    reason_id: selectedOption[index].value
                });
            }
        }
        let error = this.state.errors;
        error.rejectedReasons = null;

        this.setState({ item: temp, errors: error });
    };
    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Update record</h2>
                    <div className="model-content">
                        <form onSubmit={this.update}>
                            <div className="form-group">
                                <label htmlFor="name">Status</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    value={this.state.item.state}
                                    name="state"
                                >
                                    <option value="applied">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Declined</option>
                                </select>
                                {this.state.errors.state ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.state}
                                    </div>
                                ) : null}
                            </div>
                            {this.state.item.state === "rejected" ? (
                                <Fragment>
                                    <div className="form-group">
                                        <label htmlFor="reason_id">
                                            Reasons
                                        </label>

                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor: "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor: "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                })
                                            }}
                                            isMulti={true}
                                            name="reason_id"
                                            className="select2"
                                            value={this.state.rejectedReasons.filter(
                                                item => {
                                                    const temp = this.state.item.UserRejects.map(
                                                        item => item.reason_id
                                                    );
                                                    return (
                                                        temp.indexOf(item.id) >=
                                                        0
                                                    );
                                                }
                                            )}
                                            onChange={
                                                this.handleRejectSelectChange
                                            }
                                            options={this.state.rejectedReasons}
                                        ></Select>

                                        {this.state.errors.reason_id ? (
                                            <div className="text-danger">
                                                {this.state.errors.reason_id}
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="decline_details">
                                            Decline details
                                        </label>
                                        <textarea
                                            onChange={this.onChange.bind(this)}
                                            className="form-control"
                                            value={this.state.item.decline_details}
                                            placeholder="Decline details"
                                            name="decline_details"
                                            rows="3"
                                        ></textarea>
                                        {this.state.errors.decline_details ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.decline_details}
                                            </div>
                                        ) : null}
                                    </div>
                                </Fragment>
                            ) : (
                                <div className="form-group">
                                    <label htmlFor="name">Badges</label>
                                    <Select
                                        styles={{
                                            control: base => ({
                                                ...base,
                                                "&:hover": {
                                                    borderColor: "#1cd2ad",
                                                    boxShadow: "none"
                                                },
                                                "&": {
                                                    borderColor: "#d2ddec",
                                                    boxShadow: "none"
                                                }
                                            }),
                                            dropdownIndicator: base => ({
                                                ...base,
                                                color: "inherit"
                                            }),
                                            singleValue: base => ({
                                                ...base,
                                                color: "inherit"
                                            })
                                        }}
                                        isMulti={true}
                                        name="badges"
                                        className="select2"
                                        value={this.state.badges.filter(
                                            item => {
                                                const temp = this.state.item.user_badges.map(
                                                    item => item.badge_id
                                                );
                                                return (
                                                    temp.indexOf(item.id) >= 0
                                                );
                                            }
                                        )}
                                        onChange={this.handleSelectChange}
                                        options={this.state.badges}
                                    ></Select>
                                    {this.state.errors.badges ? (
                                        <div className="invalid-feedback">
                                            The badges field is required.
                                        </div>
                                    ) : null}
                                </div>
                            )}
                            <button
                                type="button"
                                onClick={this.update}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideUpdate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
UpdateModel.contextType = AppContext;
export default UpdateModel;



// WEBPACK FOOTER //
// ./src/components/admin/writers/UpdateModel.js